module.exports = __webpack_public_path__ + "static/media/icon-baby.e5bd32c6.svg";